<template>
  <div class="animated fadeIn">
    <div class="loading" v-if="loading">
      <square-loader :loading="true" color="#26A65B" size="50px"></square-loader>
    </div>

    <b-card>
      <b-row>
        <b-col cols='12' sm="6">
          <b-form-group v-bind:label="$t('outlet')" :label-cols="2" label-class="text-right" :horizontal="true">
            <v-select v-model="outlet" :options="outlets[$session.get('lang')]">
            </v-select>
          </b-form-group>
        </b-col>
        <!--<b-col cols="2" sm="2">
          <b-form-select v-model="filter.channel"  :options="channel[$session.get('lang')]">
          </b-form-select>
        </b-col>-->
        <b-col cols='12' sm="4">
          <b-form-group v-bind:label="$t('date')" :label-cols="2" label-class="text-right" :horizontal="true">
            <date-range-picker
              :startDate="start_date"
              :endDate="end_date"
              @update="updateDate"
              :locale-data="locale"
            >
            </date-range-picker>
          </b-form-group>
        </b-col>
        <b-col cols='12' sm="2">
          <b-button variant="success" v-on:click="refresh"> <i class="fa fa-search"></i> {{$t('search')}}</b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-row>
      <b-col cols="12">
        <b-card
          header-tag="header"
          footer-tag="footer">
          <div slot="header">
            <i className="fa fa-align-justify"></i><strong>{{ $t('list') }}</strong>
            <div class="clearfix">
              <hr/>
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm header-pointer">
                <thead>
                <tr>
                  <th scope="col" v-for="item in dataTable.header" :key="item.id" @click="updateSort(item.name)" :class="item.sort ? 'cursor-pointer' : ''">
                    <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                    <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                    <span>{{$t(item.name)}}</span>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in dataTable.body" :key="item.id">
                  <td scope="row" v-for="field in dataTable.header" :key="field.id">
                    <span v-if="field.render != null" v-html="field.render(item[field.name])"></span>
                    <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <b-row>
              <b-col>
                <b-pagination :total-rows="dataTable.total" :per-page="dataTable.paginate" v-model="dataTable.offset" />
              </b-col>
              <b-col col lg="1">
                <b-form-select v-model="dataTable.paginate" :options="[10, 20, 50, 100]" class="mb-3"/>
              </b-col>
            </b-row>
          </div>
          <b-col cols="12" class="text-center">
            <div class="clearfix">
              <hr/>
            </div>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<style scoped>
  .process-container {
    width: 100%;
    height: 35px;
  }
  .process-container .current {
    height: 35px;
    -webkit-transition: width 1s; /* Safari */
    transition:width 1s;
  }
  .process-container .target {
    width: 2px;
    height: 35px;
    margin-top: -35px;
    -webkit-transition: margin-left 1s; /* Safari */
    transition: margin-left 1s;
  }
  .loading {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 99999;
    padding-top: 300px;
  }
</style>
<script>
import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
import DateRangePicker from 'vue2-daterange-picker'
import {config, store, order_processing_time} from '@/api/report'

export default {
    name: 'OrderProcessingTime',
    components: {
      DateRangePicker,
      SquareLoader
    },
    data: function () {
      return {
        loading: true,
        date: new Date(),
        date_picker_options: {
          format: 'DD/MM/YYYY',
          useCurrent: true
        },
        start_date: this.$moment().subtract(6, 'day').format('YYYY-MM-DD'),
        end_date: this.$moment().format('YYYY-MM-DD'),
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - '
        },
        outlets: [],
        outlet: {
          label: this.$auth.user().store_code,
          value: this.$auth.user().store_code
        },
        languages: Object.keys(this.$i18n.messages),

        channel: [],

        filter: {
          channel: null
        },

        dataTable: {
          body: [],
          header: [
            {
              name: 'order_number',
              search: true,
              sort: true
            },
            {
              name: 'channel',
              search: true,
              sort: true,
            },
            {
              name: 'order_type',
              search: true,
              sort: true,
            },
            {
              name: 'order_date',
              search: true,
              sort: true
            },
            {
              name: 'sent_to_kds',
              search: true,
              sort: true
            },
            {
              name: 'cooked',
              search: true,
              sort: true
            },
            {
              name: 'delivery_start_time',
              search: true,
              sort: true
            },
            {
              name: 'customer_recieved',
              search: true,
              sort: true
            },
            {
              name: 'encashment_time',
              search: true,
              sort: true
            },
            {
              name: 'sos_achived',
              search: false,
              sort: true,
              render: (data, row) => {
                if (data == 'Y') {
                  return '<span class="text-success"><i class="fa fa-check"></i></span>'
                }
                return '<span class="text-danger"><i class="fa fa-close"></i></span>'
              }
            }
          ],
          sort: {
            field: null,
            type: 'asc'
          },
          offset: 1,
          total: 0,
          paginate: 10,
          source: null
        }
      }
    },
    methods: {
      /**
       * Refresh data of data table
       */
      refreshData () {
        this.loading = true
        let params = {
          offset: this.dataTable.offset,
          paginate: this.dataTable.paginate,
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type,
          outlet_code: this.outlet.value,
          from_date: this.start_date,
          to_date: this.end_date
        }
        let str_search_key = ''
        if (this.field == null && !this._.isEmpty(this.key)) {
          for (let i in this.dataTable.header) {
            if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
              if (str_search_key != '') {
                str_search_key += ',' + this.dataTable.header[i].name
              } else {
                str_search_key += this.dataTable.header[i].name
              }
            }
          }
          params.search_key = str_search_key
          params.search_value = this.key.trim()
        } else {
          if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
            params.search_key = this.field
            params.search_value = this.key.trim()
          }
        }
        order_processing_time(params).then((response) => {
          this.dataTable.body = response.data.data.items
          this.dataTable.total = response.data.data.total
          this.loading = false
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.response.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Refresh data
       */
      refresh () {
        this.refreshData()
      },
      /**
       * Update Date
       */
      updateDate (val) {
        this.start_date = this.$moment(val.startDate).format('YYYY-MM-DD')
        this.end_date = this.$moment(val.endDate).format('YYYY-MM-DD')
        this.refresh()
      }
    },
    created: function () {
      this.$Progress.start()

      for (let i in this.dataTable.header) {
        if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
          this.dataTable.sort = {
            field: this.dataTable.header[i].name,
            type: 'asc'
          }
        }
      }

      // Load all store
      this.axios.request({
        method: 'get',
        url: process.env.BASE_URL_REPORT + '/store',
      }).then((response) => {
        this.outlets = {}
        for (let l in this.languages) {
          this.outlets[this.languages[l]] = []
          this.outlets[this.languages[l]].push({
            label: this.$t('all', this.languages[l]),
            value: null
          })
          for (let i in response.data.data) {
            this.outlets[this.languages[l]].push({
              label: response.data.data[i].name,
              value: response.data.data[i].store_code
            })

            if (this.outlet.value == response.data.data[i].store_code) {
              this.outlet.label = response.data.data[i].name
            }
          }
        }
      }).catch((error) => {

      })

      // Load config
      config().then((response) => {
        this.channel = {}
        for (let l in this.languages) {
          this.channel[this.languages[l]] = []
          this.channel[this.languages[l]].push({
            text: this.$t('all', this.languages[l]),
            value: null
          })
          for (let c in response.data.data.channel) {
            this.channel[this.languages[l]].push({
              text: response.data.data.channel[c],
              value: response.data.data.channel[c]
            })
          }
        }
        this.refreshData()

        setInterval(() => {
          this.refreshData()
        }, 5 * 60 * 1000)
      }).catch((error) => {

      }).then(() => {
        this.$Progress.finish()
      })
    },
    watch: {
      'dataTable.offset': function () {
        this.refreshData()
      },
      'dataTable.paginate': function () {
        this.refreshData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/OrderProcessingTime.vue